import type { ReactNode } from 'react'
import { usePermissions } from '../hooks/usePermissions'
import { AccessDenied } from './AccessDenied'

interface AdminRouteProps {
  children: ReactNode
}

export function AdminRoute({ children }: AdminRouteProps) {
  const { isAdmin } = usePermissions()

  if (!isAdmin) return <AccessDenied required="admin" />

  return <>{children}</>
}
